import type { ReactNode } from 'react';
import { useAuthorization } from '@/core/hooks/useAuthorization';

interface ProtectedProps {
  children?: ReactNode;
  permissions: string | string[];
  requireAll?: boolean;
}

export default function Protected({ children, permissions, requireAll = false }: ProtectedProps) {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = useAuthorization();

  const perms = Array.isArray(permissions) ? permissions : [permissions];

  const allowed =
    perms.length === 0
      ? true
      : requireAll
        ? hasAllPermissions(perms)
        : perms.length === 1
          ? hasPermission(perms[0])
          : hasAnyPermission(perms);

  if (!allowed) return null;
  return <>{children}</>;
}
